// extracted by mini-css-extract-plugin
export default {"categoryHeader":"categoryHeader--1cb99"};